import { Button, Group } from '@mantine/core';
import { IconFileTypeDocx } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Id } from '@feature/utils';
import { ValidationStatus } from '@feature/validation';

interface AnnualReportButtonProps {
  year: number;
  validationStatus: ValidationStatus | null;
  userId: Id | null;
  filterAfterAffiliation: boolean;
}

const onDownload = (
  year: number,
  validationStatus: ValidationStatus | null,
  userId: Id | null,
  filterAfterAffiliation: boolean,
) => {
  const userQuery = userId != null ? `&userId=${userId}` : '';
  const validationQuery = validationStatus != null ? `&validationStatus=${validationStatus}` : '';
  const filterAfterAffiliationQuery = `&filterAfterAffiliation=${filterAfterAffiliation}`;
  window.open(
    `/api/annual-report/generate/rectorreport/${year}?${userQuery}${validationQuery}${filterAfterAffiliationQuery}`,
  );
};

export function AnnualReportButton({
  year,
  validationStatus,
  userId,
  filterAfterAffiliation,
}: AnnualReportButtonProps) {
  const { t } = useTranslation();
  return (
    <Group>
      <Button
        size="xs"
        leftSection={<IconFileTypeDocx size="24px" />}
        onClick={() => onDownload(year, validationStatus, userId, filterAfterAffiliation)}
      >
        {t('rectorReport.downloadButton')}
      </Button>
    </Group>
  );
}
